import React from 'react';
import { Alert, Snackbar } from "@mui/material";

export default function AlertBar({ open, message, severity, onClose }) {
  return (
    <>
      <Snackbar
        anchorOrigin={{ vertical: "top", horizontal: "right" }}
        open={open}
        onClose={onClose}
        key={"tophorizontal"}
      >
        <Alert onClose={onClose} severity={severity} sx={{ width: "100%" }}>
          {message}
        </Alert>
      </Snackbar>
    </>
  );
}
